import { useState } from "react";
import { Outlet } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";
import { AdminHeader } from "./AdminHeader";
import { AppointmentReminderPopup } from "@/components/appointments/AppointmentReminderPopup";
import { useGlobalAppointmentReminder } from "@/hooks/appointments/useGlobalAppointmentReminder";

export const AdminLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // Default to expanded

  // Global appointment reminder - monitors virtual appointments and shows popup 15 min before start
  const {
    upcomingAppointments,
    showReminder,
    dismissReminder,
  } = useGlobalAppointmentReminder();

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="h-screen bg-background flex flex-col w-full overflow-hidden">
      {/* Global Appointment Reminder Popup */}
      <AppointmentReminderPopup
        isOpen={showReminder}
        onClose={dismissReminder}
        appointments={upcomingAppointments}
      />
      
      <AdminHeader onToggleSidebar={toggleSidebar} />
      
      <div className="flex flex-1 w-full overflow-hidden">
        <AdminSidebar isCollapsed={isSidebarCollapsed} />
        
        <main className="flex-1 transition-all duration-300 p-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};